import { Component, Inject, OnInit } from '@angular/core';
import { UIActiveDialogService } from '../../services/ui-dialog.service';
import { RequestUrlUtils } from '../../utils/request.url.utils';

@Component({
  selector: 'linked-items-list-manage-dialog',
  templateUrl:
    './console/app-js/shared/components/linked-items-list-manage-dialog/linked-items-list-manage-dialog.component.html'
})
export class LinkedItemsListManageDialogComponent implements OnInit {
  protected currentItemsUsed: Array<any>;
  protected data = [];
  protected selection = [];
  private loadingIndicator = false;
  protected filterValue = '';
  private originalData;

  constructor(
    currentItem: Array<any>,
    private functionToGetItems: Function,
    @Inject('allItems') private allItems: Array<any>,
    @Inject('title') public title: string,
    @Inject('property') private property: string,
    @Inject('idField') private idField: string,
    public activeDialog: UIActiveDialogService
  ) {
    this.currentItemsUsed = [...currentItem];
    this.title = 'Manage ' + title;
  }

  ngOnInit(): void {
    this.getAvailableDataToAdd(this.allItems);
  }

  /**
   *  Getting all the available data to fill the PopUp.
   */
  private getAvailableDataToAdd(allItems: Array<any>): void {
    this.loadingIndicator = true;
    if (this.allItems && this.allItems.length > 0) {
      this.prepareDataToAdd(this.allItems);
    } else {
      this.functionToGetItems().subscribe((res: any) => {
        // Validating if result comes from Product Line, if so it should be mapped with the Name Property.
        const results = res.results.productLines
          ? res.results.productLines
          : res.results;
        this.prepareDataToAdd(results);
      });
    }
  }

  /**
   * Prepare data to manage and display on the list.
   * TODO: maybe we can be flexible to specify the propertyName as an input of the component.
   * @param {Array<any>} allItems
   */
  private prepareDataToAdd(allItems: Array<any>): void {
    const result: { result; propertyName } = {
      result: allItems,
      propertyName: this.property
    };
    // Mapping the gotten result.
    this.data = RequestUrlUtils.mapCollection(
      result.result,
      result.propertyName,
      'value',
      this.idField
    );
    this.selection = this.data.filter(item => {
      return this.currentItemsUsed.find(
        selectedItem => selectedItem[this.idField] === item[this.idField]
      );
    });
    this.loadingIndicator = false;
  }

  /**
   * Clear the input filter.
   */
  private onClearFilter(): void {
    this.filterValue = '';
    this.onFilterData();
  }

  /**
   * Executes filter when user type some value.
   */
  protected onFilterData(): void {
    if (!this.originalData) {
      this.originalData = [...this.data];
    }
    let value = this.filterValue.toLocaleLowerCase();
    // filter our data
    const temp = this.originalData.filter(r => {
      return r.value.toLowerCase().indexOf(value) !== -1 || !value;
    });
    // update the rows
    this.data = temp;
  }

  /**
   * Un-selects all the items in the manager component
   */
  public onUnselectAll(): void {
    this.selection = [];
  }

  /**
   *  Adds all the selected items and close the dialog
   */
  public onAdd() {
    this.activeDialog.close(this.selection);
  }

  /**
   * Cancel the transactions on the current open PopUp
   */
  public cancelCloseButton(): void {
    this.activeDialog.dismiss();
  }
}
